import "isomorphic-fetch";

const url = "https://staging-api.distil.ai:8888/internal-api/v0_0/";

const basicPostObject = (body, headers) => ({
    method: "POST",
    headers: {
        "Content-Type": "application/json; charset=utf-8",
        ...headers
    },
    body: JSON.stringify(body)
})

const basicPutObject = (body, headers) => ({
    method: "PUT",
    headers: {
        "Content-Type": "application/json; charset=utf-8",
        ...headers
    },
    body: JSON.stringify(body)
})

const onFetch = (onLoad) => (res) => {
    if (res.ok) {
        res.json().then(
            json => {
                onLoad(json)
            }
        )
    } else {
        onLoad(null)
    }
}

export const fetchIntegrations = (string, onLoad) => {
    fetch(url+"integration/?searchIntegration="+string).then(
        onFetch(onLoad)
    )
}

export const fetchRecommendations = (array, onLoad) => {
    fetch(url+"integration/recommendation", basicPutObject(array)).then(
        onFetch(onLoad)
    )
}

export const fetchGoals = (array, onLoad) => {
    fetch(url+"goal", basicPutObject(array)).then(
        onFetch(onLoad)
    )
}

export const submitMissingIntegration = (values, onLoad) => {
    fetch(url + "suggestion", basicPostObject(values)).then(
        onFetch(onLoad)
    )
}

export const submitData = (values, onLoad) => {
    fetch(url + "submission", basicPutObject(values)).then(
        onFetch(onLoad)
    )
}

export const createMissingIntegrationSuggestion = (integrationName, integrationWebsite, otherInformation = "", firstName = "", lastName = "", emailAddress = "") => {
    return {integrationName, integrationWebsite, otherInformation, firstName, lastName, emailAddress}
}

export const createSubmitData = (integrationId = [], goals = [], state = true) => {
    const integrationIDs = integrationId.map(i => i.id);
    let userAnonymousId = "unknown";
    try {
        userAnonymousId = JSON.parse(window.localStorage.getItem('distil-ls-key'))['distil-anonymousId-key'];
    } catch (e) {
        
    }
    return {integrationId: integrationIDs, selectedGoals: goals, state, userAnonymousId}
}
